import { registerCapability } from '../../platform/capability-registry';
import { ModelSubscriptionOtherBlock } from './ModelSubscriptionOtherBlock';
import { MS_OTHER_FIELD_KEY_LIST } from './fieldKeys';
import { resolveModelSubscriptionOtherPaths } from './resolvePaths';
import type { ModelSubscriptionOtherBlockOptions } from './types';

registerCapability<ModelSubscriptionOtherBlockOptions>({
  key: 'model-subscription-other',
  fields: [...MS_OTHER_FIELD_KEY_LIST],
  component: ModelSubscriptionOtherBlock,
  defaultPaths: (prefix) => resolveModelSubscriptionOtherPaths(prefix),
  resolvePaths: (prefix) => resolveModelSubscriptionOtherPaths(prefix),
});

export { ModelSubscriptionOtherBlock } from './ModelSubscriptionOtherBlock';
